import { PreprodPublicationAction, PreprodPublicationKeys } from '../actions/preprodPublication';
import { UiAction, UiActionKeys } from '../actions/ui';

export interface PreprodPublicationState {
	tempGId: number | null;
	lastUpdateDate: number | string | null;
	isUpdating: boolean;
	urlWithPin: string;
}

const preprodPublicationInitialState: PreprodPublicationState = {
	tempGId: null,
	lastUpdateDate: null,
	isUpdating: false,
	urlWithPin: '',
};

export const preprodPublication = (state: PreprodPublicationState = preprodPublicationInitialState, action: PreprodPublicationAction | UiAction): PreprodPublicationState => {
	switch (action.type) {
		case PreprodPublicationKeys.SET_DATA:
			return {
				...state,
				...action.data,
			};
		case PreprodPublicationKeys.SET_IS_UPDATING:
			return {
				...state,
				isUpdating: action.isUpdating,
			};
		case UiActionKeys.RESET:
			return action.isIntermediate ? state : preprodPublicationInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/preprodPublication.ts